import { createStore } from "vuex";

const DRAFT_KEY = "checkout_delivery_details_draft";

export default createStore({
  state: {
    paymentType: { id: 1 },
    deliveryType: { id: 1 },
    cart: [],
    user: {},
    lastAddedItem: null,

    // ✅ cache pro dopravy/platby
    deliveryTypesCache: null,
    paymentTypesCache: null,
    deliveryTypesFetchedAt: null,
    paymentTypesFetchedAt: null,

    // ✅ DRAFT pro checkout (formulář)
    deliveryDetailsDraft: null,
  },

  mutations: {
    // ==========================
    // checkout
    // ==========================
    updatePaymentType(state, newPaymentType) {
      state.paymentType = newPaymentType;
    },

    updateDeliveryType(state, newDeliveryType) {
      state.deliveryType = newDeliveryType;
    },

    // ==========================
    // cart
    // ==========================
    updateCart(state, newCart) {
      state.cart = newCart;
    },

    // ==========================
    // auth
    // ==========================
    updateUser(state, newUser) {
      state.user = newUser;
    },

    // ==========================
    // UI
    // ==========================
    setLastAddedItem(state, item) {
      state.lastAddedItem = item;
    },

    // ==========================
    // ✅ CACHE (MUSÍ být mutations)
    // ==========================
    setDeliveryTypesCache(state, payload) {
      state.deliveryTypesCache = payload;
      state.deliveryTypesFetchedAt = Date.now();
    },

    setPaymentTypesCache(state, payload) {
      state.paymentTypesCache = payload;
      state.paymentTypesFetchedAt = Date.now();
    },

    clearCheckoutCache(state) {
      state.deliveryTypesCache = null;
      state.paymentTypesCache = null;
      state.deliveryTypesFetchedAt = null;
      state.paymentTypesFetchedAt = null;
    },

    // ==========================
    // ✅ DRAFT
    // ==========================
    setDeliveryDetailsDraft(state, payload) {
      state.deliveryDetailsDraft = payload;
    },

    clearDeliveryDetailsDraft(state) {
      state.deliveryDetailsDraft = null;
    },
  },

  actions: {
    // ✅ načti draft z localStorage do Vuex
    loadDeliveryDetailsDraft({ commit }) {
      try {
        const raw = localStorage.getItem(DRAFT_KEY);
        if (!raw) return;
        commit("setDeliveryDetailsDraft", JSON.parse(raw));
      } catch (e) {
        console.log("Draft load failed:", e);
      }
    },

    // ✅ ulož draft do localStorage
    persistDeliveryDetailsDraft({ state }) {
      try {
        if (!state.deliveryDetailsDraft) return;
        localStorage.setItem(DRAFT_KEY, JSON.stringify(state.deliveryDetailsDraft));
      } catch (e) {
        console.log("Draft persist failed:", e);
      }
    },

    // ✅ smaž draft z localStorage + Vuex
    clearDeliveryDetailsDraft({ commit }) {
      localStorage.removeItem(DRAFT_KEY);
      commit("clearDeliveryDetailsDraft");
    },
  },

  getters: {
    deliveryDetailsDraft(state) {
      return state.deliveryDetailsDraft;
    },

    deliveryTypesCache(state) {
      return state.deliveryTypesCache;
    },

    paymentTypesCache(state) {
      return state.paymentTypesCache;
    },
  },
});
